import React, { Component } from "react";
import { connect } from "react-redux";
import IntelligentSchoolFilterGroup from "./components/IntelligentSchoolFilterGroup";
import "./style.css";
import "../../../../../index.css";

class IntelligentDataFilter extends Component {
  render() {
    const {
      visible,
      handleVisibleFilter,
      filterData,
      handleConfirm,
      userInfo,
    } = this.props;
    return (
      <div
        style={{ zIndex: 2 }}
        className={
          visible === true
            ? "school_filter_box"
            : "school_filter_box display_none"
        }
      >
        <div className="school_filter_inline_box fr">
          {filterData != null ? (
            <div>
              {filterData.map((item, index) => {
                if (
                  (item.name === "选科要求（不超过3科）" ||
                    item.name === "选科限制") &&
                  userInfo.isWhiteUser === true
                ) {
                  return (
                    <IntelligentSchoolFilterGroup
                      onRef={this.onRef.bind(this)}
                      key={index}
                      name={item.name}
                      filters={item.filters}
                    ></IntelligentSchoolFilterGroup>
                  )
                } else if (
                  item.name !== "选科要求（不超过3科）" &&
                  item.name !== "选科限制"
                ) {
                  return (
                    <IntelligentSchoolFilterGroup
                      onRef={this.onRef.bind(this)}
                      key={index}
                      name={item.name}
                      filters={item.filters}
                    ></IntelligentSchoolFilterGroup>
                  )
                }
              })}
              <div style={{ height: 60 }}></div>
              <div className="school_filter_inline_box_bottom">
                <div className="school_filter_inline_box_bottom_inline">
                  <div
                    onClick={() => this.handleReset()}
                    className="major_filter_inline_box_bottom_btn_fl fl"
                  >
                    重置
                  </div>
                  <div
                    onClick={() => handleConfirm()}
                    className="major_filter_inline_box_bottom_btn_fr fr"
                  >
                    确定
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          onClick={() => handleVisibleFilter()}
          className="school_filter_inline_click fl"
        ></div>
      </div>
    );
  }
  /**
   * 重置高校过滤组件的数据
   */
  handleReset = () => {
    this.schoolFilterGroup.resetUIState();
  };
  // 获取子组件
  onRef = (name, ref) => {
    switch (name) {
      case "schoolFilterGroup":
        this.schoolFilterGroup = ref;
        break;
      default:
        break;
    }
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};

export default connect(mapStateToProps)(IntelligentDataFilter);



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentDataFilter/index.js